export const ENABLE_AMENDMENT_V2_JOURNEY = 'enable-llc-amendment-v2-journey';
export const ENABLE_AMENDMENT_AI_SLIDE_OUT = 'enable-amendment-ai-slide-out';
export const ENABLE_ANNUAL_REPORT_V2_JOURNEY = 'enable-llc-annual-report-v-2-journey';
export const ENABLE_BLF_PRODUCT = 'enable-blf-product';
export const ENABLE_BLR_SPECIFIC_CONTENT = 'enable-blr-specific-content';
export const ENABLE_DASHBOARD_LINK_TO_MANAGE_COOKIES = 'enable-dashboard-link-to-manage-cookies';
export const ENABLE_EIN_V3_JOURNEY = 'enable-ein-v-3-journey';
export const ENABLE_FUNDBOX_QUALIFIED_LIST_CONTROL = 'enable-fundbox-qualified-list-control';
export const ENABLE_HOLIDAY_BANNER = 'enable-holiday-banner';
export const ENABLE_VELO_ASSISTANT = 'enable-velo-assistant';
export const WHILE_YOU_WAIT_WIDGET = 'while-you-wait-widget';
export const RELEASE_BUSINESS_PROFILE_V2 = 'release-business-profile-v2';
export const RELEASE_COMPANIES_PAGE = 'release-companies-page';
export const RELEASE_CONSTANT_CONTACT_PRODUCT_CARD = 'release-constant-contact-product-card';
export const RELEASE_FINANCE_HUB = 'release-finance-hub';
export const SHOW_DOWNLOAD_RECEIPTS = 'show-download-receipts';
export const SHOW_ORPHAN_ACCOUNT_OPTIONS = 'show-orphan-account-options';
export const RELEASE_APRIL_TAX_SERVICES = 'release-april-tax-services';
export const RELEASE_APRIL_TAX_SERVICES_PHASE_2 = 'release-april-tax-services-phase-2';
